<!-- Modal Overlay -->
<div class="modal-overlay" *ngIf="isVisible" (click)="fecharModal()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    
    <!-- Modal Header -->
    <div class="modal-header">
      <h2 class="modal-title">
        <i class="fas fa-user"></i>
        {{ isEditando ? 'Editar Cliente' : 'Cadastrar Cliente' }}
      </h2>
      <button type="button" class="btn-close" (click)="fecharModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Modal Body -->
    <div class="modal-body">
      <form [formGroup]="formCliente" (ngSubmit)="salvarCliente()" class="form-cliente">
        
        <!-- Dados Pessoais -->
        <div class="form-section">
          <h3 class="section-title">Dados Pessoais</h3>
          <div class="form-row three-columns">
            <div class="form-group">
              <label for="nome">Nome Completo *</label>
              <input 
                type="text" 
                id="nome" 
                formControlName="nome" 
                class="form-control" 
                [class.is-invalid]="isCampoInvalido('nome')"
                placeholder="Digite o nome completo">
              <div class="invalid-feedback" *ngIf="isCampoInvalido('nome')">
                {{ getMensagemErro('nome') }}
              </div>
            </div>
            <div class="form-group">
              <label for="cpf">CPF *</label>
              <input 
                type="text" 
                id="cpf" 
                formControlName="cpf" 
                class="form-control" 
                [class.is-invalid]="isCampoInvalido('cpf')"
                placeholder="000.000.000-00">
              <div class="invalid-feedback" *ngIf="isCampoInvalido('cpf')">
                {{ getMensagemErro('cpf') }}
              </div>
            </div>
            <div class="form-group">
              <label for="senha">Senha de Acesso *</label>
              <input 
                type="password" 
                id="senha" 
                formControlName="senha" 
                class="form-control" 
                [class.is-invalid]="isCampoInvalido('senha')"
                placeholder="Digite a senha">
              <div class="invalid-feedback" *ngIf="isCampoInvalido('senha')">
                {{ getMensagemErro('senha') }}
              </div>
            </div>
          </div>
          
          <div class="form-row three-columns">
            <div class="form-group">
              <label for="email">Email/Login *</label>
              <input 
                type="email" 
                id="email" 
                formControlName="email" 
                class="form-control" 
                [class.is-invalid]="isCampoInvalido('email')"
                placeholder="exemplo@email.com">
              <div class="invalid-feedback" *ngIf="isCampoInvalido('email')">
                {{ getMensagemErro('email') }}
              </div>
            </div>
            <div class="form-group">
              <label for="telefone_celular">Telefone Celular *</label>
              <input 
                type="tel" 
                id="telefone_celular" 
                formControlName="telefone_celular" 
                class="form-control" 
                [class.is-invalid]="isCampoInvalido('telefone_celular')"
                placeholder="(00) 00000-0000">
              <div class="invalid-feedback" *ngIf="isCampoInvalido('telefone_celular')">
                {{ getMensagemErro('telefone_celular') }}
              </div>
            </div>
            <div class="form-group">
              <label for="telefone_adicional">Telefone Adicional</label>
              <input 
                type="tel" 
                id="telefone_adicional" 
                formControlName="telefone_adicional" 
                class="form-control" 
                placeholder="(00) 0000-0000">
            </div>
          </div>
        </div>

        <!-- Endereço -->
        <div class="form-section">
          <h3 class="section-title">Endereço</h3>
          <div class="form-row">
            <div class="form-group">
              <label for="rua">Logradouro *</label>
              <input 
                type="text" 
                id="rua" 
                formControlName="rua" 
                class="form-control" 
                [class.is-invalid]="isCampoInvalido('rua')"
                placeholder="Rua, Avenida, etc.">
              <div class="invalid-feedback" *ngIf="isCampoInvalido('rua')">
                {{ getMensagemErro('rua') }}
              </div>
            </div>
            <div class="form-group">
              <label for="numero">Número *</label>
              <input 
                type="text" 
                id="numero" 
                formControlName="numero" 
                class="form-control" 
                [class.is-invalid]="isCampoInvalido('numero')"
                placeholder="123">
              <div class="invalid-feedback" *ngIf="isCampoInvalido('numero')">
                {{ getMensagemErro('numero') }}
              </div>
            </div>
            <div class="form-group">
              <label for="complemento">Complemento</label>
              <input 
                type="text" 
                id="complemento" 
                formControlName="complemento" 
                class="form-control" 
                placeholder="Apartamento, bloco, etc.">
            </div>
            <div class="form-group">
              <label for="bairro">Bairro *</label>
              <input 
                type="text" 
                id="bairro" 
                formControlName="bairro" 
                class="form-control" 
                [class.is-invalid]="isCampoInvalido('bairro')"
                placeholder="Nome do bairro">
              <div class="invalid-feedback" *ngIf="isCampoInvalido('bairro')">
                {{ getMensagemErro('bairro') }}
              </div>
            </div>
          </div>
          
          <div class="form-row">
            <div class="form-group">
              <label for="cep">CEP *</label>
              <input 
                type="text" 
                id="cep" 
                formControlName="cep" 
                class="form-control" 
                [class.is-invalid]="isCampoInvalido('cep')"
                placeholder="00000-000">
              <div class="invalid-feedback" *ngIf="isCampoInvalido('cep')">
                {{ getMensagemErro('cep') }}
              </div>
            </div>
            <div class="form-group">
              <label for="pais">País *</label>
              <select 
                id="pais" 
                formControlName="pais" 
                class="form-control" 
                [class.is-invalid]="isCampoInvalido('pais')">
                <option value="">Selecione o país</option>
                <option value="Brasil">Brasil</option>
                <option value="Italia">Itália</option>
                <option value="Estados Unidos">Estados Unidos</option>
                <option value="Argentina">Argentina</option>
                <option value="Uruguai">Uruguai</option>
              </select>
              <div class="invalid-feedback" *ngIf="isCampoInvalido('pais')">
                {{ getMensagemErro('pais') }}
              </div>
            </div>
            <div class="form-group">
              <label for="estado">Estado *</label>
              <select 
                id="estado" 
                formControlName="estado" 
                class="form-control" 
                [class.is-invalid]="isCampoInvalido('estado')">
                <option value="">Selecione o estado</option>
                <option value="SP">São Paulo</option>
                <option value="RJ">Rio de Janeiro</option>
                <option value="MG">Minas Gerais</option>
                <option value="RS">Rio Grande do Sul</option>
                <option value="PR">Paraná</option>
                <option value="SC">Santa Catarina</option>
                <option value="BA">Bahia</option>
                <option value="GO">Goiás</option>
                <option value="MT">Mato Grosso</option>
                <option value="MS">Mato Grosso do Sul</option>
              </select>
              <div class="invalid-feedback" *ngIf="isCampoInvalido('estado')">
                {{ getMensagemErro('estado') }}
              </div>
            </div>
            <div class="form-group">
              <label for="cidade">Cidade *</label>
              <input 
                type="text" 
                id="cidade" 
                formControlName="cidade" 
                class="form-control" 
                [class.is-invalid]="isCampoInvalido('cidade')"
                placeholder="Nome da cidade">
              <div class="invalid-feedback" *ngIf="isCampoInvalido('cidade')">
                {{ getMensagemErro('cidade') }}
              </div>
            </div>
          </div>
        </div>

        <!-- Informações Adicionais -->
        <div class="form-section">
          <h3 class="section-title">Informações Adicionais</h3>
          <div class="form-row two-columns">
            <div class="form-group link-field">
              <label for="LINK_PASTA">Link Pasta Virtual</label>
              <input 
                type="url" 
                id="link_pasta" 
                formControlName="link_pasta" 
                class="form-control" 
                placeholder="https://exemplo.com/pasta">
            </div>
            <div class="form-group">
              <label for="PASTA_FISICA">Pasta Física?</label>
              <div class="toggle-container">
                <label class="toggle-switch">
                  <input type="checkbox" id="pasta_fisica" formControlName="pasta_fisica">
                  <span class="toggle-slider"></span>
                </label>
                <span class="toggle-label">{{ formCliente.get('PASTA_FISICA')?.value ? 'Sim' : 'Não' }}</span>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group full-width">
              <label for="apelido_pasta_virtual">Apelido Pasta Virtual</label>
              <input
                type="text"
                id="apelido_pasta_virtual"
                formControlName="apelido_pasta_virtual"
                class="form-control"
                placeholder="Ex.: Pasta Família Rossi">
            </div>
          </div>
         
          <div class="form-row">
            <div class="form-group full-width">
              <label for="OBSERVACOES">Observação</label>
              <textarea 
                id="observacoes" 
                formControlName="observacoes" 
                class="form-control" 
                rows="4" 
                placeholder="Digite observações adicionais..."></textarea>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="fecharModal()">
        <i class="fas fa-times"></i> Cancelar
      </button>
      <button type="button" class="btn btn-secondary" (click)="limparFormulario()">
        <i class="fas fa-eraser"></i> Limpar
      </button>
      <button type="button" class="btn btn-primary" (click)="salvarCliente()" [disabled]="formCliente.invalid">
        <i class="fas fa-save"></i> {{ isEditando ? 'Atualizar' : 'Salvar' }} Cliente
      </button>
    </div>
  </div>
</div>
